module.exports = __webpack_public_path__ + "img/full-slide-2.94462d71.jpg";